const nameElement = document.getElementById("contactName")
const emailElement = document.getElementById("contactEmail")
const messageElement = document.getElementById("contactMessage")
const inputs = [nameElement, emailElement, messageElement]

const errorElement = document.getElementById("contactError")

const button = document.getElementById("contactButton")
const spinner = document.getElementById("contactSpinner")

const state = {
  name: null,
  email: null,
  message: null,
  error: true
}

const handleChange = e => {
  state[e.target.name] = e.target.value
  const element = document.getElementById(e.target.id)
  element.classList.remove("error")
  errorElement.classList.remove("display")
}

const hasErrors = () => {
  if (!state.name) {
    nameElement.classList.add("error")
    return true
  }
  if (!state.email) {
    emailElement.classList.add("error")
    return true
  }
  if (!state.message) {
    messageElement.classList.add("error")
    return true
  }
  return false
}

const setLoading = (loading) => {
  if (loading) {
    spinner.classList.add("display")
    deactivateInputs()
  } else {
    activateInputs()
    spinner.classList.remove("display")
  }
}

const handleSubmit = async (e) => {
  e.preventDefault()
  setLoading(true)

  try {

    if (hasErrors()) {
      setLoading(false)
      return
    }

    const res = await postData()
    if (res.status !== 200) {
      errorElement.classList.add("display")
      setLoading(false)
      return
    }
    document.getElementById("contactSuccess").classList.add("display")
    spinner.classList.remove("display")
  } catch (e) {
    console.log('e', e)
    errorElement.classList.add("display")
    setLoading(false)
  }


}

const deactivateInputs = () => {
  inputs.forEach(element => {
    element.readOnly = true
  })
  button.disabled = true
}

const activateInputs = () => {
  inputs.forEach(element => {
    element.readOnly = false
  })
  button.disabled = false
}

async function postData() {
  // Default options are marked with *
  const response = await fetch("https://reality-stack.de/api/", {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      "Accept": "application/json"
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify({
      name: state.name,
      email: state.email,
      message: state.message,
    }) // body data type must match "Content-Type" header
  });
  return response; // parses JSON response into native JavaScript objects
}

document.getElementById("contactForm").addEventListener("submit", handleSubmit);
nameElement.addEventListener("input", handleChange)
emailElement.addEventListener("input", handleChange)
messageElement.addEventListener("input", handleChange)
